module.exports = __webpack_public_path__ + "img/mit2.adca47fe.png";